import React from "react"
import styles from './ChatAgents.module.css'
import userIcon from '../../../../assets/userIcon.png'
// import serverUrl from '../../../../serverUrl'

import * as settings from '../../../../settings'

const serverUrl = process.env.NODE_ENV === 'production' ? settings.SERVER_URL_PROD : settings.SERVER_URL_DEV

const ChatAgents = (props) => {
    let agentStatus = undefined
    let notSeenSpan = undefined

    if (props.notSeenCount > 0) {
        notSeenSpan = props.loggedNowAgent !== props.agentName && <span className={styles.agentNotSeenSpan}>{props.notSeenCount}</span>
    }
    if (props.isOnline) {
        agentStatus = <div key={props.agentName} className={styles.agentDiv} >
            {/* <img  alt='Cant load img' src={ serverUrl + '/users/avatar/' + props.avatarImg} onError={(event) => event.target.src = userIcon} className={styles.user_img_online} /> */}
            {/* <img loading="lazy" alt='Cant load img' src={userIcon} onError={(event) => event.target.src = userIcon} className={styles.user_img_online} /> */}
            <img loading="lazy" alt='Cant load img' src={props.avatarImg  ? serverUrl + `/users/${props.userId}/avatar` : userIcon } onError={(event) => event.target.src = userIcon} className={styles.user_img_online} />
            <p className={styles.agentNameP}>
                {/* {notSeenSpan}{props.agentName} */}
                {notSeenSpan && <span className={styles['not-seen-messages-on-agent']}>
                    {notSeenSpan}
                </span>}
                <span className={styles['agent-name']}>
                    {props.name ? props.name : props.agentName}
                </span>
            </p>
        </div>
    }
    else {
        agentStatus = <div key={props.agentName} className={styles.agentDiv} >
            {/* <img  alt='Cant load img' src={serverUrl + '/users/avatar/' + props.avatarImg} onError={(event) => event.target.src = userIcon} className={styles.user_img_offline} />  */}
            {/* <img loading="lazy" alt='Cant load img' src={userIcon} onError={(event) => event.target.src = userIcon} className={styles.user_img_offline} />  */}
            <img loading="lazy" alt='Cant load img' src={props.avatarImg  ? serverUrl + `/users/${props.userId}/avatar` : userIcon } onError={(event) => event.target.src = userIcon} className={styles.user_img_offline} /> 
            <p className={styles.agentNameP}>
                {notSeenSpan && <span className={styles['not-seen-messages-on-agent']}>
                    {notSeenSpan}
                </span>}
                <span className={styles['agent-name']}>
                    {props.name ? props.name : props.agentName}
                </span>

            </p>
        </div>
    }
    return (
        agentStatus
    )
}

export default ChatAgents;